import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { ToastType } from "@/enums";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast, displayToast } from "@/utils/toast";

export interface SetBreakGlassPasswordPayload {
  password: string;
  confirm_password: string;
}

export const useSetBreakGlassPassword = () => {
  const userToken = useUserToken();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: SetBreakGlassPasswordPayload) =>
      fetch(ENDPOINTS.mfa.break_glass_password, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify(payload),
      }).then(handleResponse),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["mfa", "policy"] });
      displayToast("Emergency access password saved", ToastType.success);
    },
    onError: (error: unknown) => {
      displayErrorToast(error);
    },
  });
};
